import React from 'react'
import PropTypes from 'prop-types'
import HrbTranslate from '../../language/HrbTranslate';
import Skeleton from '../loaders/Skeleton';
import EmdashText from '../common/EmdashText';

const VerticalNameValue = props =>
    <div>
        <span><HrbTranslate text={props.textKey} /></span><br />
        {props.values && props.values.map((v, i) =>
            (<p key={`vnv_${i}`} className='p1 medium-weight wrap-anywhere'>{v}</p>)
        )}
        {props.value && !props.loading &&
            <p className='p1 medium-weight wrap-anywhere'>{props.value}</p>
        }
        {(!props.value && !props.values) && !props.loading &&
            <p className='p1 medium-weight'><EmdashText /></p>
        }
        {props.loading &&
            <Skeleton />
        }
    </div>

VerticalNameValue.propTypes = {
    textKey: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    values: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
    ])
}

export default VerticalNameValue